export { default as DE } from "./de.json";
export const FOR_USERS_NAMESPACE = "forUsers";
export const FOR_USERS_DOI_NAMESPACE = "doi";
export const FOR_USERS_RESET_PASSOWORD_NAMESPACE = "resetPassword";
